import { api } from '../api';
import {
  GET_ASSETS_LIST_SELECTOR,
  GET_ASSETS_PRICE_OTC_TICKER,
  GET_OTC_CHART_DATA,
  GET_OTC_MARKET_STATUS,
  OTC_ORDER_INIT
} from '../../constants/otc';
import {
  GetMarketSelectorsResponse,
  GetMarketStatusResponse,
  getOtcMarketTickerResponse,
  OtcKlineRequest,
  OtcKlineResponse,
  OtcOrderInitRequest,
  OtcOrderInitResponse
} from './types';
import { LOGIN } from '../../constants';

export const otcSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getMarketStatus: build.query<GetMarketStatusResponse, void>({
      query: () => `${GET_OTC_MARKET_STATUS}`
    }),
    getMarketSelectors: build.query<GetMarketSelectorsResponse, void>({
      query: () => `${GET_ASSETS_LIST_SELECTOR}`
    }),
    getOtcMarketTicker: build.query<getOtcMarketTickerResponse, string | null>({
      query: (symbol) =>
        symbol
          ? `${GET_ASSETS_PRICE_OTC_TICKER}?symbol=${symbol}`
          : `${GET_ASSETS_PRICE_OTC_TICKER}`,
      providesTags: ['getOtcMarketTicker']
    }),
    getOtcKline: build.query<OtcKlineResponse, OtcKlineRequest>({
      query: (data) =>
        `${GET_OTC_CHART_DATA}?symbol=${data.symbol}&interval=${data.interval}&limit=${data.limit}&endTime=${data.endTime}`
    }),
    otcOrderInit: build.mutation<OtcOrderInitResponse, OtcOrderInitRequest>({
      query(data) {
        return {
          url: OTC_ORDER_INIT,
          method: 'POST',
          body: data
        };
      },
      invalidatesTags: ['UserAssets']
    })
  }),
  overrideExisting: false
});
export const {
  useGetMarketStatusQuery,
  useGetMarketSelectorsQuery,
  useGetOtcMarketTickerQuery,
  useGetOtcKlineQuery,
  useLazyGetOtcKlineQuery,
  useOtcOrderInitMutation
} = otcSlice;
